import {
  AccountRouteEnum,
  DepositRouteEnum,
  PromotionRouteEnum,
  RoutesEnum,
  WithdrawRouteEnum,
} from '~/enums/routes'

export const IMAGE_LINK_DEFAULT: string = '/assets/images/lazyload.gif'
export const IMAGE_HR_BANNER_DEFAULT: string =
  '/images/banner/banner-empty.webp'
export const IMAGE_BANK_DEFAULT: string = '/images/bank/default.svg'
export const NOTIFICATION_TIMEOUT: number = 2000
export const WINDOW_WIDTH_RESIZE: number = 1363
export const DEBOUNCE_SEARCH: number = 1000
export const DEBOUNCE_CHECK_FULL_NAME: number = 1000
export const TYPE_DIVIDE: string = 'divider'
export const TIME_OUT_TRACKING: number = 1000
export const NUMBER_BILLIONAIRE: number = 2690000000
export const JACKPOT_BILLIONAIRE_DEFAULT: string = '2,000,000,000'
export const NUMBER_LUCKY: number = 500000000
export const VISIBLE_TIMEOUT: number = 300
export const USER_TOTAL_STAKE = 5000000
export const FULLSCREEN_MOBILE_URL = [
  DepositRouteEnum.Deposit,
  WithdrawRouteEnum.Withdraw,
  AccountRouteEnum.UserBank,
  AccountRouteEnum.ChangePassword,
  RoutesEnum.FavoriteGames,
  RoutesEnum.RecentPlayedGames,
  AccountRouteEnum.AccountInformation,
  AccountRouteEnum.MyPromotion,
  AccountRouteEnum.BetHistory,
  AccountRouteEnum.Transaction,
  AccountRouteEnum.TransactionCoin12,
  PromotionRouteEnum.FirstDepositPromotion,
  PromotionRouteEnum.SecondDepositPromotion,
  PromotionRouteEnum.UnlimitedDepositPromotion,
  PromotionRouteEnum.SanSieuHutPromotion,
  RoutesEnum.News,
  RoutesEnum.FootballNews,
  RoutesEnum.TinNoiBat,
  RoutesEnum.TipFootball,
  RoutesEnum.LodeOnline,
  RoutesEnum.Maintenance,
]
export const CURRENT_DATE_FORMAT = 'DD/MM/YYYY HH:mm'
export const MAINTENANCE_DATE_FORMAT = 'YYYY-MM-DD HH:mm'
export const INNER_WIDTH_DESKTOP = 1200
